import { useSelector } from "react-redux";
import DashboardMain from "../DashboardMain";
import DashboardIcon from "../../assets/Icons/Dashboard.svg";
import Settings from "../settings/Settings";
import MenuManagement from "../menu_management/MenuManagement";
import Vendor from "../vendor/Vendor";
import UserMaster from "../users/UserMaster";
import CustomerMaster from "../customer/CustomerMaster";
import CustomerIcon from "../../assets/Icons/Customer Master.svg";
import UsersIcon from "../../assets/Icons/usericon.svg";
import WalletBlueIcon from "../../assets/Icons/Walletwhite_icon.svg";
import VendorMasterIcon from "../../assets/Icons/Vendor Master.svg";
import TxnReport from "../../assets/Icons/report_icon_01.svg";
import OrderMasterIcon from "../../assets/Icons/Order_master_white.svg";
import SettingsIcon from "../../assets/Icons/SettingsIcon.svg";
import MenuManagementIcon from "../../assets/Icons/MenuManagementIcon.svg";
import APIDocIcon from "../../assets/Icons/api document.svg";
import VendorHistoryIcon from "../../assets/Icons/Vendor History.svg";
import RoleMasterIcon from "../../assets/Icons/role master.svg";
import TopUpReqIcon from "../../assets/Icons/Topup request.svg";
import CourierMasterIcon from "../../assets/Icons/Courier_add_icon.svg";
import LedgerIcon from "../../assets/Icons/Ledger_icon.svg";
import APIDoc from "../apidocument/APIDoc";
import DLT from "../dlt/DLT";
import RoleMaster from "../role/RoleMaster";
import TopUpReq from "../topuprequest/TopUpReq";
import VendorTxnHistory from "../vendorhistory/VendorTxtHistory";
import TopUpMainWalletReq from "../topupmainwalletrequest/TopUpMainWalletReq";
import TransactionReport from "../transactionReport/TransactionReport";
import CourierMaster from "../courier/CourierMaster";
import OrderMaster from "../order/OrderMaster";
import Ledger from "../ledger/Ledger";
import RCSCarouselIcon from "../../assets/Icons/rcs_carousel02.svg";
import CustomerEnquiries from "../CustomerEnquiries/CustomerEnquiries";
import OtpEnquiries from "../OtpEnquiries/OtpEnquiries";
import PickupAddress from "../pickupaddress/PickupAddress";
import BookingMaster from "../booking/BookingMaster";
import BagCourier from "../CourierBag/BagCourier";
import ReportCourier from "../ReportCourier/ReportCourier";
import OrderCourierHub from "../orderCourierHub/OrderCourierHub";
import ReportOrderMaster from "../reportOrder/ReportOrderMaster";
import CourierHub from "../CourierHub/CourierHub";
import NotificationMaster from "../../pages/Master/NotificationMaster";
import NotificationMasterHub from "../../pages/Master/NotificationMasterHub";
import DeliveryMaster from "../../pages/Master/DeliveryMaster";
import ChargeMaster from "../../pages/Master/ChargeMaster/index";
import RateCalculator from "../../pages/Master/RateCalculator/index";
import PincodeServiceability from "../../pages/Master/PincodeServiceability/PincodeServiceability";
import FranchiseMaster from "../../pages/Master/FranchiseMaster/FranchiseMaster";
import GenerateSticker from "../../pages/Master/GenerateSticker";
import LedgerReport from "../../pages/Report/LedgerReport";
import Statement from "../../pages/Report/Statement/Statement";
import LMBPRateCalculator from "../../pages/Master/LMBPRateCalculator/LMBPRateCalculator";
import StationaryMaster from "../../pages/Master/StationaryMaster";
import BuyStationaryMaster from "../../pages/Master/BuyStationaryMaster";
import WalletTopup from "../../pages/Payment/WalletTopup";
import UploadVegaahReport from "../../pages/Report/VegaahReport/VegaahReport";
import PaymentHistoryMaster from "../../pages/Master/PaymentHistoryMaster";
import RateCardMaster from "../../pages/Master/RateCardMaster";
import ChargeMasterNew from "../../pages/Master/NewChargeMaster";

const Routes = () => {
  const { menu } = useSelector((state) => state.auth);

  const array1 = menu;

  const array =
    menu !== null &&
    menu !== undefined &&
    menu !== "" &&
    array1?.split("").map((char) => parseInt(char));

  const userRole = sessionStorage.getItem("userRole");
  const canViewOtpEnquiries = userRole === "ADMK" || userRole === "ADCH";

  const PROTECTED_ROUTES = [
    {
      name: "Home",
      id: "dashboard",
      url: array[0] === 1 ? "/dashboard" : null,
      component: <DashboardMain />,
      arr: array[0],
      roles: [],
      Icon: DashboardIcon,
    },
    // Payment Gateway Not Use
    // {
    //   name: "Payment Gateway",
    //   id: "paymentGateway",
    //   url: array[0] === 1 ? "/payment-gateway" : null,
    //   component: <PaymentGateway />,
    //   arr: array[0],
    //   roles: [],
    //   Icon: WalletBlueIcon,
    // },
    // User Controller
    {
      name: "User Master",
      id: "userMaster",
      url: array[1] === 1 ? "/userMaster" : null,
      component: <UserMaster />,
      arr: array[1],
      roles: [],
      Icon: UsersIcon,
    },
    {
      name: "User Master",
      id: "userMaster",
      url: array[1] === 1 ? "/userMaster" : null,
      roles: [],
      Icon: UsersIcon,
      menuShow: true,
      grandChild: [
        { arr: array[2] },
        { arr: array[3] },
        { arr: array[4] },
        { arr: array[5] },
        { arr: array[54] },
        null,
        null,
        { arr: array[82] },
      ],
    },
    {
      name: "Create User",
      id: "create",
      url: array[2] === 1 ? "/create" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Edit User",
      id: "edit",
      url: array[3] === 1 ? "/edit" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Suspend User",
      id: "delete",
      url: array[4] === 1 ? "/delete" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Authorize User",
      id: "auth",
      url: array[5] === 1 ? "/auth" : null,
      roles: [],
      component: <UserMaster />,
      Icon: UsersIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[54] === 1 ? "/audittrl" : null,
      roles: [],
      component: <UserMaster />,
      Icon: CustomerIcon,
    },
    // Vendor Controller
    {
      name: "Vendor Master",
      id: "vendorMaster",
      url: array[6] === 1 ? "/vendorMaster" : null,
      component: <Vendor />,
      arr: array[6],
      roles: [],
      Icon: VendorMasterIcon,
    },
    {
      name: "Vendor Master",
      id: "vendorMaster",
      url: array[6] === 1 ? "/vendorMaster" : null,
      roles: [],
      Icon: VendorMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[7] },
        { arr: array[8] },
        { arr: array[9] },
        { arr: array[10] },
        { arr: array[55] },
      ],
    },
    {
      name: "Create Vendor",
      id: "create",
      url: array[7] === 1 ? "/create" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Edit Vendor",
      id: "edit",
      url: array[8] === 1 ? "/edit" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Suspend Vendor",
      id: "delete",
      url: array[9] === 1 ? "/delete" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Authorize Vendor",
      id: "auth",
      url: array[10] === 1 ? "/auth" : null,
      roles: [],
      component: <Vendor />,
      Icon: VendorMasterIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[55] === 1 ? "/audittrl" : null,
      roles: [],
      component: <Vendor />,
      Icon: CustomerIcon,
    },

    {
      name: "Customer Enquiries",
      id: "customerEnquiries",
      url: array[75] === 1 ? "/customerEnquiries" : null,
      component: <CustomerEnquiries />,
      arr: array[75],
      roles: [],
      Icon: CustomerIcon,
    },
    {
      name: "OTP Enquiries",
      id: "otpEnquiries",
      url:
        array[75] === 1 && canViewOtpEnquiries ? "/otpEnquiries" : null,
      component: <OtpEnquiries />,
      arr: array[75],
      roles: [],
      Icon: CustomerIcon,
    },

    // Customer Controller
    {
      name: "LMBP Master",
      id: "CustomerOnboarding",
      url: array[11] === 1 ? "/CustomerOnboarding" : null,
      component: <CustomerMaster />,
      arr: array[11],
      roles: [],
      Icon: CustomerIcon,
    },
    {
      name: "Customer Onboarding",
      id: "CustomerOnboarding",
      url: array[11] === 1 ? "/CustomerOnboarding" : null,
      roles: [],
      Icon: CustomerIcon,
      grandChild: [
        { arr: array[12] },
        { arr: array[13] },
        { arr: array[14] },
        { arr: array[15] },
        { arr: array[56] },
        { arr: array[16] },
      ],
    },

    // Franchise Master
    {
      name: "Franchise Master",
      id: "FranchiseOnboarding",
      url: array[116] === 1 ? "/FranchiseOnboarding" : null,
      component: <FranchiseMaster />,
      arr: array[116],
      roles: [],
      Icon: CustomerIcon,
    },
    {
      name: "Franchise Onboarding",
      id: "FranchiseOnboarding",
      url: array[116] === 1 ? "/FranchiseOnboarding" : null,
      roles: [],
      Icon: CustomerIcon,
      grandChild: [
        { arr: array[117] },
        { arr: array[118] },
        { arr: array[119] },
        { arr: array[120] },
        { arr: array[121] },
        { arr: array[122] },
      ],
    },

    {
      name: "Courier Hub",
      id: "CourierHub",
      url: array[88] === 1 ? "/CourierHub" : null,
      component: <CourierHub />,
      arr: array[88],
      roles: [],
      Icon: CustomerIcon,
    },
    {
      name: "Courier Hub",
      id: "CourierHub",
      url: array[88] === 1 ? "/CourierHub" : null,
      roles: [],
      Icon: CustomerIcon,
      grandChild: [
        { arr: array[89] },
        { arr: array[90] },
        { arr: array[91] },
        { arr: array[92] },
        { arr: array[93] },
        { arr: array[94] },
      ],
    },
    // Customer Controller
    {
      name: "Courier Master",
      id: "courierCompanyOnboarding",
      url: array[61] === 1 ? "/courierCompanyOnboarding" : null,
      component: <CourierMaster />,
      arr: array[61],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Courier Master",
      id: "courierCompanyOnboarding",
      url: array[61] === 1 ? "/courierCompanyOnboarding" : null,
      roles: [],
      Icon: CourierMasterIcon,
      grandChild: [
        { arr: array[62] },
        { arr: array[63] },
        { arr: array[64] },
        { arr: array[65] },
        null,
        null,
        { arr: array[75] },
      ],
    },
    // Booking Master
    {
      name: "Bag",
      id: "bag",
      url: array[44] === 1 ? "/bag" : null,
      component: <BookingMaster />,
      arr: array[44],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Bag",
      id: "bag",
      url: array[44] === 1 ? "/bag" : null,
      roles: [],
      Icon: CourierMasterIcon,
      grandChild: [
        { arr: array[45] },
        null,
        null,
        null, //modify
        null, //view
        null,
        null,
      ],
    },
    {
      name: "Bag Master",
      id: "bagCourier",
      url: array[49] === 1 ? "/bagCourier" : null,
      component: <BagCourier />,
      arr: array[49],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Bag Master",
      id: "bagCourier",
      url: array[49] === 1 ? "/bagCourier" : null,
      roles: [],
      Icon: CourierMasterIcon,
      grandChild: [
        { arr: array[50] },
        null,
        null,
        null, //modify
        null, //view
        null,
        null,
      ],
    },

    {
      name: "Notification Master",
      id: "notificationMaster",
      url: array[86] === 1 ? "/notificationMaster" : null,
      component: <NotificationMaster />,
      arr: array[86],
      roles: [],
      Icon: CourierMasterIcon,
    },

    {
      name: "Notification Master",
      id: "notificationMasterHub",
      url: array[87] === 1 ? "/notificationMasterHub" : null,
      component: <NotificationMasterHub />,
      arr: array[87],
      roles: [],
      Icon: CourierMasterIcon,
    },

    {
      name: "Delivery Master",
      id: "deliveryMaster",
      url: array[110] === 1 ? "/deliveryMaster" : null,
      component: <DeliveryMaster />,
      arr: array[110],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Delivery Master",
      id: "deliveryMaster",
      url: array[110] === 1 ? "/deliveryMaster" : null,
      roles: [],
      Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[111] },
        { arr: array[112] },
        { arr: array[113] },
        { arr: array[114] },
      ],
    },

    {
      name: "Order Courier",
      id: "ordercourier",
      url: array[60] === 1 ? "/orderCourier" : null,
      component: <OrderCourierHub />,
      arr: array[60],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Order Courier",
      id: "ordercourier",
      url: array[60] === 1 ? "/orderCourier" : null,
      roles: [],
      Icon: CourierMasterIcon,
      grandChild: [
        null,
        null,
        null,
        null, //modify
        null, //view
        null,
        null,
      ],
    },

    // Pickup Address
    {
      name: "Pickup Address",
      id: "pickuporder",
      url: array[77] === 1 ? "/pickuporder" : null,
      component: <PickupAddress />,
      arr: array[77],
      roles: [],
      Icon: CourierMasterIcon,
    },
    {
      name: "Pickup Address",
      id: "pickuporder",
      url: array[77] === 1 ? "/pickuporder" : null,
      roles: [],
      Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[78] }, // Create
        { arr: array[79] }, // Fetch
        { arr: array[80] }, // Modify
        { arr: array[81] }, // View
      ],
    },
    {
      name: "Create Pickup Address",
      id: "create",
      url: array[78] === 1 ? "/pickuporder/create" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "Fetch Pickup Address",
      id: "fetch",
      url: array[79] === 1 ? "/pickuporder/fetch" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "Modify Pickup Address",
      id: "modify",
      url: array[80] === 1 ? "/pickuporder/modify" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    {
      name: "View Pickup Address",
      id: "view",
      url: array[81] === 1 ? "/pickuporder/view" : null,
      roles: [],
      component: <PickupAddress />,
      Icon: CourierMasterIcon,
    },
    //Order Master
    {
      name: "Order Master",
      id: "orderMaster",
      url: array[66] === 1 ? "/orderMaster" : null,
      component: <OrderMaster />,
      arr: array[66],
      roles: [],
      Icon: OrderMasterIcon,
    },
    {
      name: "Order Master",
      id: "orderMaster",
      url: array[66] === 1 ? "/orderMaster" : null,
      roles: [],
      Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[83] }, // Fetch
        { arr: array[84] }, // Modify
        // { arr: array[81] }, // View
      ],
    },

    // Report Order Master
    {
      name: "Order Master",
      id: "orderMaster",
      url: array[66] === 1 ? "/reportOrderMaster" : null,
      component: <ReportOrderMaster />,
      arr: array[66],
      roles: [],
      Icon: OrderMasterIcon,
    },
    {
      name: "Create Customer",
      id: "create",
      url: array[12] === 1 ? "/create" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Edit Customer",
      id: "edit",
      url: array[13] === 1 ? "/edit" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Suspend Customer",
      id: "delete",
      url: array[14] === 1 ? "/delete" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "Authorize Customer",
      id: "auth",
      url: array[15] === 1 ? "/auth" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "DLT",
      id: "dlt",
      url: array[16] === 1 ? "/dlt" : null,
      roles: [],
      component: <DLT />,
      Icon: CustomerIcon,
    },
    {
      name: "Audit Trial",
      id: "audittrl",
      url: array[56] === 1 ? "/audittrl" : null,
      roles: [],
      component: <CustomerMaster />,
      Icon: CustomerIcon,
    },
    {
      name: "API Document",
      id: "api-document",
      url: array[24] === 1 ? "api-document" : null,
      component: <APIDoc />,
      arr: array[24],
      roles: [],
      Icon: APIDocIcon,
    },
    {
      name: "Menu Management",
      id: "menuManagement",
      url: array[28] === 1 ? "/menuManagement" : null,
      component: <MenuManagement />,
      arr: array[28],
      roles: [],
      Icon: MenuManagementIcon,
    },
    // Role Controller
    {
      name: "Role Master",
      id: "roleMaster",
      url: array[31] === 1 ? "/roleMaster" : null,
      component: <RoleMaster />,
      arr: array[31],
      roles: [],
      Icon: RoleMasterIcon,
    },
    {
      name: "Role Master",
      id: "roleMaster",
      url: array[31] === 1 ? "/roleMaster" : null,
      roles: [],
      Icon: RoleMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[32] },
        { arr: array[33] },
        { arr: array[34] },
        { arr: array[35] },
      ],
    },
    {
      name: "Create Role",
      id: "create",
      url: array[32] === 1 ? "/create" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Edit Role",
      id: "edit",
      url: array[33] === 1 ? "/edit" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Suspend Role",
      id: "delete",
      url: array[34] === 1 ? "/delete" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Authorize Role",
      id: "auth",
      url: array[35] === 1 ? "/auth" : null,
      roles: [],
      component: <RoleMaster />,
      Icon: RoleMasterIcon,
    },
    {
      name: "Create Role",
      id: "create",
      url: array[37] === 1 ? "/create" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Edit Role",
      id: "edit",
      url: array[38] === 1 ? "/edit" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Suspend Role",
      id: "delete",
      url: array[39] === 1 ? "/delete" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Authorize Role",
      id: "auth",
      url: array[40] === 1 ? "/auth" : null,
      roles: [],
      component: <TopUpReq />,
      Icon: TopUpReqIcon,
    },
    {
      name: "Vendor History",
      id: "vendortxnhistory",
      url: array[41] === 1 ? "/vendortxnhistory" : null,
      component: <VendorTxnHistory />,
      arr: array[41],
      roles: [],
      Icon: VendorHistoryIcon,
    },

    //Recharge/BBPS
    {
      name: "Recharge/BBPS",
      id: "transactionReport",
      url: array[60] === 1 ? "/transactionReport" : null,
      component: <TransactionReport />,
      arr: array[60],
      roles: [],
      Icon: TxnReport,
    },
    // Main Wallet
    {
      name: "Main Wallet",
      id: "topUpMainWallet",
      url: array[49] === 1 ? "/topUpMainWallet" : null,
      component: <TopUpMainWalletReq />,
      arr: array[49],
      roles: [],
      Icon: WalletBlueIcon,
    },
    {
      name: "Main Wallet",
      id: "topUpMainWallet",
      url: array[49] === 1 ? "/topUpMainWallet" : null,
      roles: [],
      Icon: WalletBlueIcon,
      menuShow: true,
      grandChild: [
        { arr: array[50] }, // Create
        { arr: array[57] }, // Modify (custom index)
        { arr: array[53] }, // Delete
        { arr: array[51] }, // Authorize
        { arr: array[52] }, // Audit Trail
        { arr: array[58] }, // DLT
        { arr: array[59] }, // Checker
      ],
    },
    // Top-Up Wallet
    {
      name: "Top-Up Wallet",
      id: "topUpWallet",
      url: array[134] === 1 ? "/topUpWallet" : null,
      component: <WalletTopup />,
      arr: array[134],
      roles: [],
      Icon: WalletBlueIcon,
    },
    {
      name: "Top-Up Wallet",
      id: "topUpWallet",
      url: array[134] === 1 ? "/topUpWallet" : null,
      component: <WalletTopup />,
      arr: array[134],
      roles: [],
      Icon: WalletBlueIcon,
    },
    //Ledger Page
    {
      name: "Ledger",
      id: "ledger",
      url: array[67] === 1 ? "/ledger" : null,
      component: <Ledger />,
      arr: array[67],
      roles: [],
      Icon: LedgerIcon,
    },
    {
      name: "Ledger Report",
      id: "ledgerReport",
      url: array[67] === 1 ? "/ledgerReport" : null,
      component: <LedgerReport />,
      arr: array[67],
      roles: [],
      Icon: LedgerIcon,
    },
    {
      name: "Report Courier",
      id: "reportCourier",
      url: array[24] === 1 ? "/reportCourier" : null, // you can also use a new index if backend provides one
      component: <ReportCourier />,
      arr: array[24],
      roles: [],
      Icon: CourierMasterIcon,
    },
    //Setting
    {
      name: "Settings",
      id: "settings",
      url: array[29] === 1 ? "/settings" : null,
      component: <Settings />,
      arr: array[29],
      roles: [],
      Icon: SettingsIcon,
    },
    {
      name: "Rate Card Master",
      id: "rateCardMaster",
      url: array[139] === 1 ? "/rateCardMaster" : null,
      component: <RateCardMaster />,
      arr: array[139],
      roles: [],
      Icon: RCSCarouselIcon,
    },

    {
      name: "Rate Card Master",
      id: "rateCardMaster",
      url: array[139] === 1 ? "/rateCardMaster" : null,
      roles: [],
      Icon: RCSCarouselIcon,
      menuShow: true,
      grandChild: [
        { arr: array[140] },
        { arr: array[141] },
      ],
    },
    {
      name: "Charges Master",
      id: "chargeMaster",
      url: array[95] === 1 ? "/chargesMaster" : null,
      component: <ChargeMaster />,
      arr: array[95],
      roles: [],
      Icon: RCSCarouselIcon,
    },

    {
      name: "Charges Master",
      id: "chargeMaster",
      url: array[95] === 1 ? "/chargesMaster" : null,
      roles: [],
      Icon: RCSCarouselIcon,
      menuShow: true,
      grandChild: [
        { arr: array[96] },
        { arr: array[97] },
        { arr: array[98] },
        { arr: array[99] },
      ],
    },

    // New Charges Master
      {
      name: "Charges Master New",
      id: "chargeMasterNew",
      url: array[95] === 1 ? "/chargesMasterNew" : null,
      component: <ChargeMasterNew />,
      arr: array[95],
      roles: [],
      Icon: RCSCarouselIcon,
    },

    {
      name: "Charges Master New",
      id: "chargeMasterNew",
      url: array[95] === 1 ? "/chargesMasterNew" : null,
      roles: [],
      Icon: RCSCarouselIcon,
      menuShow: true,
      grandChild: [
        { arr: array[96] },
        { arr: array[97] },
        { arr: array[98] },
        { arr: array[99] },
      ],
    },

    {
      name: "Pincode Serviceability",
      id: "pincodeServiceability",
      url: array[100] === 1 ? "/pincodeServiceability" : null,
      component: <PincodeServiceability />,
      arr: array[100],
      roles: [],
      // Icon: CourierMasterIcon,
    },
    {
      name: "Pincode Serviceability",
      id: "pincodeServiceability",
      url: array[100] === 1 ? "/pincodeServiceability" : null,
      roles: [],
      // Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[101] },
        { arr: array[102] },
        { arr: array[103] },
        { arr: array[104] },
      ],
    },

    {
      name: "Statement",
      id: "statement",
      url: array[126] === 1 ? "/statement" : null,
      component: <Statement />,
      arr: array[126],
      roles: [],
    },

    {
      name: "Upload Card RAW File",
      id: "rawFileUpload",
      url: array[135] === 1 ? "/rawFileUpload" : null,
      component: <UploadVegaahReport />,
      arr: array[135],
      roles: [],
      Icon: RCSCarouselIcon,
    },

    {
      name: "Upload Card RAW File",
      id: "rawFileUpload",
      url: array[135] === 1 ? "/rawFileUpload" : null,
      roles: [],
      Icon: RCSCarouselIcon,
      menuShow: true,
      grandChild: [
        { arr: array[136] },
        { arr: array[137] },
      ],
    },

    // TODO Only fetch
    {
      name: "Payment History",
      id: "paymentHistory",
      url: array[138] === 1 ? "/paymentHistory" : null,
      component: <PaymentHistoryMaster />,
      arr: array[138],
      roles: [],
      Icon: RCSCarouselIcon,
    },

    {
      name: "Rate Calculator",
      id: "rateCalculator",
      url: array[105] === 1 ? "/rateCalculator" : null,
      component: <RateCalculator />,
      arr: array[105],
      roles: [],
      // Icon: CourierMasterIcon,
    },
    {
      name: "Rate Calculator",
      id: "rateCalculator",
      url: array[105] === 1 ? "/rateCalculator" : null,
      roles: [],
      // Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[106] },
        { arr: array[107] },
        { arr: array[108] },
        { arr: array[109] },
      ],
    },
    {
      name: "LMBP Rate Calculator",
      id: "lmbpRateCalculator",
      url: array[127] === 1 ? "/lmbpRateCalculator" : null,
      component: <LMBPRateCalculator />,
      arr: array[127],
      roles: [],
      // Icon: CourierMasterIcon,
    },

    {
      name: "Generate Sticker",
      id: "orderMaster",
      url: array[123] === 1 ? "/generateSticker" : null,
      component: <GenerateSticker />,
      arr: array[123],
      roles: [],
      Icon: OrderMasterIcon,
    },
    {
      name: "Generate Sticker",
      id: "orderMaster",
      url: array[123] === 1 ? "/generateSticker" : null,
      roles: [],
      Icon: CourierMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[124] }, // Fetch
      ],
    },
    //Stationary Master
    {
      name: "Stationary Master",
      id: "stationaryMaster",
      url: array[128] === 1 ? "/stationaryMaster" : null,
      component: <StationaryMaster />,
      arr: array[128],
      roles: [],
      Icon: VendorMasterIcon,
    },
    {
      name: "Stationary Master",
      id: "stationaryMaster",
      url: array[128] === 1 ? "/stationaryMaster" : null,
      roles: [],
      Icon: VendorMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[129] }, // Create
        { arr: array[130] }, // Modify
      ],
    },
    //Buy Stationary
    {
      name: "Buy Stationary",
      id: "buyStationaryMaster",
      url: array[131] === 1 ? "/buyStationaryMaster" : null,
      component: <BuyStationaryMaster />,
      arr: array[131],
      roles: [],
      Icon: VendorMasterIcon,
    },
    {
      name: "Buy Stationary",
      id: "buyStationaryMaster",
      url: array[131] === 1 ? "/buyStationaryMaster" : null,
      roles: [],
      Icon: VendorMasterIcon,
      menuShow: true,
      grandChild: [
        { arr: array[132] },
        { arr: array[133] },
        { arr: array[134] },
      ],
    },
  ];
  return {
    PROTECTED_ROUTES,
  };
};
export default Routes;
//Last Used 54-138
